import dynamic from 'next/dynamic'

// es importante cargarlo así por que Leaflet no funciona correctamente con ssr.
const Map = dynamic(() => import('./Map'), {
  ssr: false
})

export default Map
